<template>
  <form-custom-field :submit="submit" :formTitle="'Custom Field Details'" role="update"></form-custom-field>
</template>
<script>
import { mapActions } from "vuex";
import { Loading, MessageBox } from "element-ui";
import FormCustomField from "./FormCustomField";
import { userRolesCheck } from "@/util/userRoles";
import Swal from "sweetalert2";

export default {
  components: {
    "form-custom-field": FormCustomField,
  },
  methods: {
    ...mapActions("customFields", ["postCustomField"]),
    submit() {
      let loadingInstance = Loading.service({
        fullscreen: true,
      });
      this.postCustomField()
        .then((response) => {
          loadingInstance.close();
          Swal.fire({
            icon: "success",
            title: "Update custom field success",
            text: "update saved",
            onClose: () => {
              this.$router.push({ name: "Custom Fields" });
            }
          });
        })
        .catch((error) => {
          loadingInstance.close();
          this.$notify({
            message: "Update custom field failed",
            timeout: 5000,
            icon: "now-ui-icons ui-1_bell-53",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
  },
};
</script>
<style scoped>
</style>
